import { Component } from 'react'
import { Drawer } from 'antd';
import Helper from '../utils/helper';
import { Region } from '../utils/commonInterfaces';
import { getRegion } from './regionWrapper';

interface Props {
  drawerLayout: any,
  drawerTitle?: string,
  showDrawer: any,
  cancelDrawer: any,
  visible: boolean,
  drawerWidth?: any,
  hiddenScroll?: boolean
}

class CommanDrawer extends Component<Props> {

  closeDirectly = () => {
    const { cancelDrawer } = this.props;
    if (cancelDrawer) {
      cancelDrawer('direct');
    }
  }

  handleClose = (e: any) => {
    if (e && e.target) {
      const target = e.target as HTMLElement;
      if (target.classList.contains('ant-drawer-close') ||
        target.closest('.ant-drawer-close')) {
        this.closeDirectly();
        return;
      }
    }

    const { cancelDrawer } = this.props;
    const region = getRegion() ?? Region.EG;
    if (cancelDrawer && region === Region.SE) {
      cancelDrawer();
    }
  }

  render() {
    const { drawerLayout, drawerTitle, visible, drawerWidth, hiddenScroll, cancelDrawer } = this.props;
    let intFrameWidth: number = window.innerWidth * 0.8;
    const region = getRegion() ?? Region.EG;
    return (
      <div>
        <>
          <Drawer
            title={drawerTitle ? drawerTitle : "Create a new account"}
            headerStyle={{ textAlign: Helper.isArabic(drawerTitle) ? 'end' : 'end' }}
            width={drawerWidth < intFrameWidth ? drawerWidth : intFrameWidth}
            onClose={region === Region.SE ? this.handleClose : cancelDrawer}
            maskClosable={true}
            open={visible}
            bodyStyle={{
              paddingBottom: 80, padding: Helper.isArabic(drawerTitle) ? 0 : 24,
              overflowY: hiddenScroll ? 'hidden' : 'auto', direction: Helper.isArabic(drawerTitle) ? 'rtl' : 'ltr',
              overflowX: "hidden"
            }}
          >
            {drawerLayout}
            <Drawer
              title="Two-level Drawer"
              width={320}
              closable={false}
              onClose={() => { }}
              open={false}
            >
              This is two-level drawer
            </Drawer>
          </Drawer>
        </>
      </div >
    )
  }
}
export default CommanDrawer